import React, { FC, ReactElement } from 'react';
import {useSelector} from 'react-redux';
import {internalizationState} from '../../../../../stores/reducers/sections';
import localeFieldResolver from '../../../../../helpers/locale-field-finder';

interface Props {
  speakers: any[];
  allowTargetBeforeStart?: boolean;
  questionModalhandler?: CallableFunction;
  viewParams?: any;
}

const ColumnsView: FC<Props> = ({ speakers }): ReactElement => {
  const { activeLangState } = useSelector(internalizationState);

  return (
    <div className="speakers-columns">
      { 
        speakers &&
        speakers.length &&
        speakers.map((speaker: any, index: number) => (
          <div key={index} className="speakers-columns__item">
            <div className="speakers-columns__item__image">
              <img src={speaker.photo} alt={ localeFieldResolver(speaker, 'fullnameRu', activeLangState) } />
            </div>
            <p className="speakers-columns__item__name">
              { localeFieldResolver(speaker, 'fullnameRu', activeLangState) }
            </p>
            <p className="speakers-columns__item__description user-fs-text__sm">
              { localeFieldResolver(speaker, 'descriptionRu', activeLangState) }
            </p>
          </div>
        ))
      }
    </div>
  )
}

export default ColumnsView;
